// LoadingContext.js
import React, { createContext, useContext, useState, useEffect } from "react";
import authservice from "../../src/services/auth.service";
import { useLocation } from "react-router-dom";

const LoadingContext = createContext();

export const LoadingProvider = ({ children }) => {
  const location = useLocation();
  const isUrlTrackingPage = location.pathname.startsWith("/urlTracking");
  const [loading, setLoading] = useState(false);
  const [notificationState, setNotificationState] = useState([]);

  const GetToastNotification = async () => {
    const jsonData = {
      stateID: parseInt(localStorage.getItem("stateID")),
      isFilter: 1,
      type: "ALERT",
      isRead: "false",
    };

    await authservice.postJsonData("Api/getNotifications", jsonData).then(
      (res) => {
        if (res?.apiResponseCode == "1001") {
          setNotificationState("res?.notifications");
          let toastData = res?.notifications;
          if (localStorage.getItem("toast") != null) {
            toastData = JSON.parse(localStorage.getItem("toast")).concat(
              res?.notifications,
            );
          }
          localStorage.setItem("toast", JSON.stringify(toastData));
        }
      },
      (error) => {
        const message =
          (error.res && error.res.data && error.res.data.message) ||
          error.message ||
          error.toString();
        console.warn(message);
      },
    );
  };

  useEffect(() => {
    const lastLoginAt = localStorage.getItem("lastLoginAt");
    const accountType = localStorage.getItem("accountType");
    let notificationTimeId;
    if (
      !isUrlTrackingPage &&
      lastLoginAt &&
      (accountType == "ERS" || accountType == "MST")
    ) {
      notificationTimeId = setInterval(() => {
        GetToastNotification();
      }, process.env.REACT_APP_NOTIFICATION_TIMEOUT);
    }

    return () => {
      clearInterval(notificationTimeId);
    };
  }, []);

  return (
    <LoadingContext.Provider
      value={{ loading, setLoading, notificationState, setNotificationState }}
    >
      {children}
    </LoadingContext.Provider>
  );
};

export const useLoading = () => {
  return useContext(LoadingContext);
};
